module.exports = __webpack_public_path__ + "img/home_bg_left.35cd9b5c.png";